/**
 * Cómo se muestra el estatus y la forma de pago de una venta en las tablas
 * (Ventas, Compras del cliente). Antes cada lista repetía estas reglas.
 */

// Una venta con saldo y no cancelada se llama "Emitida" (pendiente de cobro),
// aunque el backend diga otro estatus.
export const isPendingSale = (sale) => sale.ventaEstatus !== 'Cancelada' && sale.saldo > 0;

/** Props de `StatusChip` para el estatus de la venta. */
export function ventaStatusChip(sale) {
    if (isPendingSale(sale)) return { label: 'Emitida', tone: 'pending' };
    // El catálogo del backend trae el color del resto de los estatus.
    return { label: sale.ventaEstatus, color: sale.colorEstatus };
}

/** Tono de la forma de pago: de contado o liquidada es verde; a crédito con saldo, pendiente. */
export function pagoTone(sale) {
    return (sale.tipoPago.id == 1 || sale.saldo === 0) ? 'success' : 'pending';
}
